<template>
  <div class="pywx-tab">
    <SlideSearch
      :categoryList="searchCategory"
      :filterList="searchFilter"
      @search="subminSearch"
      @offsearch="offSearch"
      ref="search"
    ></SlideSearch>

    <Pagination
      class="book-pages"
      :num="pageNow"
      :pages="pages"
      @change="chagenPage"
    ></Pagination>

    <div class="data-list">
      <swiper :options="swiperOption" ref="bookSwiper">
        <swiper-slide
          v-for="(slide, index) in datalist"
          :key="index"
        >
          <div class="book-item" @click="showContent(slide)">
            <h3>{{slide.title | title}}</h3>
            <span>{{slide.author | title}}</span>
          </div>
          <div class="book-desc">
            <p v-html="desc(slide.description)"></p>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="search-bottom">
      <div class="btn-search" @click="showSearch">
        <img src="@/assets/img/icon-search-light.png">
        {{ $t("base.search") }}
      </div>
    </div>

    <TextContent
      :content="content"
      :headers="headers"
      v-if="contentPage"
      @close="contentPage = false"
    ></TextContent>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import SlideSearch from "./SlideSearch";
import Pagination from "@/components/Pagination";
import TextContent from "./TextContent";

export default {
  components: {
    SlideSearch,
    Pagination,
    TextContent
  },
  computed: {
    ...mapState(["literature"]),
    datalist() {
      if (this.onSearch) {
        return this.literature.searchres.content;
      }
      return this.literature[this.pageNow];
    },
    pageNow() {
      return this.onSearch
        ? this.literature.searchres.number
        : this.literature.number;
    },
    pages() {
      return this.onSearch
        ? this.literature.searchres.total_pages
        : this.literature.total_pages;
    },
    swiper() {
      return this.$refs.bookSwiper.swiper;
    }
  },
  data() {
    return {
      pageName: "literature",
      swiperOption: {
        centeredSlides: true,
        slidesPerView: 1.5,
        spaceBetween: 15
      },
      headers: [
        { tag: "region", name: "国别" },
        { tag: "author", name: "作者" },
        { tag: "publisher", name: "出版社" },
        { tag: "publish_place", name: "出版地" },
        { tag: "publish_date", name: "出版时间" },
        { tag: "category", name: "类别" },
        { tag: "description", name: "简介" },
        { tag: "note", name: "备注" }
      ],
      onSearch: false,
      searchCategory: ["影卷", "近现代书目", "古籍", "图像", "音像资料"],
      searchFilter: [
        { name: "title", title: "题名" },
        { name: "author", title: "作者" },
        { name: "publisher", title: "出版社" },
        { name: "description", title: "简介" }
      ],
      searchParam: {},
      contentPage: false,
      content: {}
    };
  },
  filters: {
    title(value) {
      return value.length > 10 ? value.slice(0, 10) + "\n." : value;
    },
    
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["getDataList", "searchData"]),
    getPageData(page_num = 0) {
      const param = {
        data_name: this.pageName,
        page_num
      };
      this.getDataList(param);
    },
    chagenPage(num) {
      this.onSearch
        ? this.search(this.searchParam, num)
        : this.getPageData(num);
      this.swiper.slideTo(0);
    },
    desc(value) {
      return value.length > 24 ? value.slice(0, 24) + "..." : value;
    },
    showSearch() {
      this.$refs.search.slideSearch = true;
    },
    search(param, num = 0) {
      this.searchData({
        data_name: this.pageName,
        page_num: num,
        ...param
      });
      this.searchParam = param;
      this.onSearch = true;
    },
    subminSearch(data) {
      this.search(data);
      this.swiper.slideTo(0);
    },
    offSearch() {
      this.getPageData();
      this.onSearch = false;
      this.swiper.slideTo(0);
    },
    showContent(data) {
      this.content = data;
      this.contentPage = true;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.pywx-tab {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem 0;
  overflow: hidden;

  .search-bar {
    display: none;
  }

  .book-pages {
    margin-bottom: 0.5rem;
  }

  .data-list {
    flex: 1;

    .swiper-container {
      height: 100%;
      z-index: 0;

      .swiper-slide {
        max-height: 100%;
      }

      .swiper-slide-next,
      .swiper-slide-prev {
        transform: scale(0.95);
      }
    }

    .book-item {
      position: relative;
      width: 15rem;
      height: 20rem;
      background-image: url("~@/assets/img/book-bg.png");
      background-repeat: no-repeat;
      background-size: 100%;
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.4);

      h3 {
        position: absolute;
        right: 3.5rem;
        width: 1rem;
        margin-top: 2rem;
        line-height: 1.2;
      }

      span {
        position: absolute;
        right: 5.35rem;
        bottom: 2rem;
        width: 1rem;
        line-height: 1.2;
      }
    }

    .book-desc {
      position: absolute;
      width: 80%;
      height: 3.2rem;
      margin-left: 1rem;
      padding-left: 1rem;
      overflow: hidden;
      font-size: 0.875rem;
      line-height: 1.25;
      border-left: 1px solid #c7ba9f;
    }
  }

  .search-bottom {
    padding-top: 1rem;
    text-align: center;

    .btn-search {
      display: inline-block;
      height: 2.125rem;
      padding: 0.5rem 2rem;
      line-height: 1.25rem;
      color: #fff;
      background-color: #a13426;
      border-radius: 1rem;
      box-shadow: 0 3px 8px rgba(161, 52, 38, 0.5);

      @include img-fluid-height;
      img {
        display: inline-block;
        margin-right: 0.5rem;
        vertical-align: top;
      }

      &:active,
      &:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
